import { Icon } from '@iconify/react'
import type { ManagerialDashboardShareCandidate } from '@/types/api'
import styles from './ShareAccessModal.module.css'

type InstitutionPickerProps = {
  search: string
  onSearchChange: (value: string) => void
  candidates: readonly ManagerialDashboardShareCandidate[]
  selectedId: string
  onSelect: (institutionId: string) => void
  isSearching: boolean
  disabled?: boolean
}

export function InstitutionPicker({
  search,
  onSearchChange,
  candidates,
  selectedId,
  onSelect,
  isSearching,
  disabled = false,
}: InstitutionPickerProps) {
  const listId = 'share-institution-results'
  const selectedCandidate = candidates.find((candidate) => String(candidate.id) === selectedId)

  return (
    <div className={styles.picker}>
      <label className={styles.field} htmlFor="share-institution-search">
        Instituição
        <span className={styles.pickerSearch}>
          <Icon icon="mdi:magnify" className={styles.pickerSearchIcon} aria-hidden />
          <input
            id="share-institution-search"
            className={styles.pickerInput}
            type="search"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Buscar por nome ou e-mail"
            autoComplete="off"
            disabled={disabled}
            role="combobox"
            aria-expanded
            aria-controls={listId}
            aria-autocomplete="list"
            aria-activedescendant={
              selectedCandidate ? `share-institution-option-${selectedCandidate.id}` : undefined
            }
          />
        </span>
      </label>

      <ul className={styles.pickerList} id={listId} role="listbox" aria-label="Contas encontradas">
        {isSearching && candidates.length === 0 ? (
          <li className={styles.pickerEmpty}>Buscando contas...</li>
        ) : null}
        {!isSearching && candidates.length === 0 ? (
          <li className={styles.pickerEmpty}>Nenhuma conta encontrada.</li>
        ) : null}
        {candidates.map((candidate) => {
          const optionId = String(candidate.id)
          const isSelected = optionId === selectedId
          return (
            <li key={candidate.id}>
              <button
                type="button"
                id={`share-institution-option-${candidate.id}`}
                className={isSelected ? styles.pickerOptionSelected : styles.pickerOption}
                role="option"
                aria-selected={isSelected}
                disabled={disabled}
                onClick={() => onSelect(optionId)}
              >
                <span className={styles.pickerOptionText}>
                  <span className={styles.pickerOptionName}>{candidate.name}</span>
                  <span className={styles.pickerOptionEmail}>{candidate.email}</span>
                </span>
                {isSelected ? (
                  <Icon icon="mdi:check-circle" className={styles.pickerCheck} aria-hidden />
                ) : null}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
